import {createReducer, on} from '@ngrx/store';
import {
  clearStopManyProductionInstancesState,
  stopManyProductionInstances,
  stopManyProductionInstancesFailure,
  stopManyProductionInstancesSuccess
} from './production-instance.stop-many.actions';


export interface State {
  record: null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const stopManyProductionInstancesReducer = createReducer(
  initialState,

  on(stopManyProductionInstances, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true
  })),
  on(stopManyProductionInstancesSuccess, (): State => ({
    record: null,
    error: null,
    loaded: true,
    loading: false
  })),
  on(stopManyProductionInstancesFailure, (_state: State, action: { error: any }): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearStopManyProductionInstancesState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);

